(function () {
  function ProductV3Gallery(root, data) {
    this.root = root;
    this.data = data;
    this.track = root.querySelector("[data-gallery-track]");
    this.thumbsWrap = root.querySelector("[data-gallery-thumbs]");
    this.prevBtn = root.querySelector("[data-gallery-prev]");
    this.nextBtn = root.querySelector("[data-gallery-next]");
    this.pager = root.querySelector("[data-gallery-pager]");
    this.pagerCurrent = root.querySelector("[data-gallery-pager-current]");
    this.pagerTotal = root.querySelector("[data-gallery-pager-total]");
    this.main = root.querySelector(".product-v3__gallery-main");
    this.currentIndex = 0;
    this.images = [];
    this.bindEvents();
    this.bindSwipe();
    this.setVariant(data.initialVariantId);
  }

  ProductV3Gallery.prototype.bindEvents = function () {
    var self = this;
    if (this.prevBtn) {
      this.prevBtn.addEventListener("click", function () {
        self.goTo(self.currentIndex - 1);
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener("click", function () {
        self.goTo(self.currentIndex + 1);
      });
    }
    document.addEventListener("variant:changed", function (event) {
      if (!event.detail || !event.detail.variant) return;
      self.setVariant(event.detail.variant.id);
    });
  };

  ProductV3Gallery.prototype.bindSwipe = function () {
    var self = this;
    if (!this.main) return;

    var startX = 0;
    var startY = 0;
    var tracking = false;
    var axis = null;

    this.main.addEventListener(
      "touchstart",
      function (event) {
        if (!self.images || self.images.length < 2) return;
        var touch = event.changedTouches[0];
        startX = touch.clientX;
        startY = touch.clientY;
        tracking = true;
        axis = null;
      },
      { passive: true }
    );

    this.main.addEventListener(
      "touchmove",
      function (event) {
        if (!tracking) return;
        var touch = event.changedTouches[0];
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
        if (axis === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
          axis = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
        }
      },
      { passive: true }
    );

    this.main.addEventListener("touchend", function (event) {
      if (!tracking) return;
      tracking = false;
      if (axis !== "x") return;
      var dx = event.changedTouches[0].clientX - startX;
      if (Math.abs(dx) < 40) return;
      self.goTo(self.currentIndex + (dx < 0 ? 1 : -1));
    });
  };

  ProductV3Gallery.prototype.getVariantImages = function (variantId) {
    var variant = this.data.variants.find(function (item) {
      return item.id === variantId;
    });
    if (variant && variant.images && variant.images.length) {
      return variant.images;
    }
    return this.data.productImages || [];
  };

  ProductV3Gallery.prototype.setVariant = function (variantId) {
    this.images = this.getVariantImages(variantId);
    this.currentIndex = 0;
    this.render();
  };

  ProductV3Gallery.prototype.render = function () {
    var self = this;
    if (!this.track || !this.thumbsWrap) return;

    this.track.innerHTML = "";
    this.thumbsWrap.innerHTML = "";

    if (!this.images.length) {
      this.track.innerHTML =
        '<div class="product-v3__gallery-slide"><span class="product-v3__sold-out">No image</span></div>';
      this.updateNav();
      this.updatePager();
      return;
    }

    this.images.forEach(function (image, index) {
      var slide = document.createElement("div");
      slide.className = "product-v3__gallery-slide";
      slide.innerHTML =
        '<img src="' +
        image.src +
        '" alt="' +
        (image.alt || "") +
        '" loading="' +
        (index === 0 ? "eager" : "lazy") +
        '">';
      self.track.appendChild(slide);

      var thumb = document.createElement("button");
      thumb.type = "button";
      thumb.className = "product-v3__thumb" + (index === 0 ? " is-active" : "");
      thumb.innerHTML =
        '<img src="' + (image.thumb || image.src) + '" alt="' + (image.alt || "") + '" loading="lazy">';
      thumb.addEventListener("click", function () {
        self.goTo(index);
      });
      self.thumbsWrap.appendChild(thumb);
    });

    this.updateNav();
    this.updatePager();
    this.updateTransform();
  };

  ProductV3Gallery.prototype.goTo = function (index) {
    if (!this.images.length) return;
    this.currentIndex = Math.max(0, Math.min(index, this.images.length - 1));
    this.updateTransform();
    this.updateNav();
    this.updatePager();
    this.updateThumbs();
  };

  ProductV3Gallery.prototype.updateTransform = function () {
    if (!this.track) return;
    this.track.style.transform = "translateX(-" + this.currentIndex * 100 + "%)";
  };

  ProductV3Gallery.prototype.updateNav = function () {
    var hasMany = this.images.length > 1;
    if (this.prevBtn) {
      this.prevBtn.disabled = !hasMany || this.currentIndex === 0;
      this.prevBtn.hidden = !hasMany;
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = !hasMany || this.currentIndex === this.images.length - 1;
      this.nextBtn.hidden = !hasMany;
    }
  };

  ProductV3Gallery.prototype.updatePager = function () {
    if (!this.pager) return;
    var total = this.images.length;
    var hasMany = total > 1;
    this.pager.hidden = !hasMany;
    if (this.pagerCurrent) {
      this.pagerCurrent.textContent = hasMany ? String(this.currentIndex + 1) : "1";
    }
    if (this.pagerTotal) {
      this.pagerTotal.textContent = String(Math.max(total, 1));
    }
  };

  ProductV3Gallery.prototype.updateThumbs = function () {
    if (!this.thumbsWrap) return;
    var wrap = this.thumbsWrap;
    var current = this.currentIndex;
    wrap.querySelectorAll(".product-v3__thumb").forEach(function (thumb, index) {
      thumb.classList.toggle("is-active", index === current);
      if (index !== current) return;
      var box = wrap.getBoundingClientRect();
      var rect = thumb.getBoundingClientRect();
      if (rect.left < box.left || rect.right > box.right) {
        var left = wrap.scrollLeft + rect.left - box.left - (box.width - rect.width) / 2;
        wrap.scrollTo({ left: Math.max(0, left), behavior: "smooth" });
      }
    });
  };
  window.ProductV3Gallery = ProductV3Gallery;
})();
